import { Facebook, ExternalLink, Users, ThumbsUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import Reveal from "@/components/site/Reveal";
import { SITE } from "@/lib/site";

export default function FacebookFeed() {
  return (
    <section id="terkini" data-testid="facebook-section" className="py-24 md:py-32 bg-[#F8F9FA] border-y border-slate-200">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#1D4ED8]">
              <Facebook className="h-4 w-4" /> Perkembangan Terkini
            </span>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A2540]">
              Ikuti kemas kini terkini di Facebook saya
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Dapatkan tips pinjaman perumahan, hartanah terkini dan kisah kejayaan
              pelanggan secara langsung dari Facebook rasmi saya. Tekan butang di bawah
              untuk melihat semua post terkini &amp; ikuti saya.
            </p>
            <a href={SITE.facebookUrl} target="_blank" rel="noopener noreferrer" data-testid="facebook-visit-btn">
              <Button className="mt-7 h-12 px-7 bg-[#1877F2] hover:bg-[#0f66d0] text-white rounded-full transition-transform hover:scale-105">
                <Facebook className="mr-2 h-5 w-5" /> Lawati Halaman Facebook
                <ExternalLink className="ml-2 h-4 w-4" />
              </Button>
            </a>
          </Reveal>

          <Reveal delay={0.15}>
            <a
              href={SITE.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="facebook-card"
              className="block group rounded-3xl bg-white border border-slate-200 overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.05)] transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="h-28 bg-gradient-to-r from-[#1877F2] to-[#0A2540]" />
              <div className="px-7 pb-7 -mt-12">
                <div className="flex items-end gap-4">
                  <div className="h-24 w-24 rounded-2xl border-4 border-white bg-white overflow-hidden shadow-md">
                    <img src={SITE.photo} alt={SITE.agentName} className="h-full w-full object-cover object-top" />
                  </div>
                  <div className="pb-1">
                    <div className="inline-flex items-center gap-1.5 rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-[#1877F2]">
                      <Facebook className="h-3.5 w-3.5" /> Facebook
                    </div>
                  </div>
                </div>
                <h3 className="mt-4 font-heading text-xl font-bold text-[#0A2540]">{SITE.agentName}</h3>
                <p className="text-sm text-slate-500">{SITE.agency} • Perunding Hartanah</p>
                <p className="mt-4 text-sm text-slate-600 leading-relaxed">
                  Post terkini tentang hartanah, tips pinjaman &amp; kisah kejayaan pelanggan
                  dikemas kini di Facebook saya. Ikuti untuk tidak ketinggalan.
                </p>
                <div className="mt-5 flex items-center gap-6 text-sm text-slate-500">
                  <span className="flex items-center gap-2"><Users className="h-4 w-4 text-[#1877F2]" /> Ikuti Saya</span>
                  <span className="flex items-center gap-2"><ThumbsUp className="h-4 w-4 text-[#1877F2]" /> Kemas kini kerap</span>
                </div>
                <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#1877F2] px-5 py-2.5 text-sm font-semibold text-white transition-colors group-hover:bg-[#0f66d0]">
                  <Facebook className="h-4 w-4" /> Lihat Post di Facebook
                  <ExternalLink className="h-4 w-4" />
                </div>
              </div>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
